document.addEventListener('turbo:load', (event) => {
  const button = document.querySelector('#user-menu-button');
  const menu = document.querySelector('#user-dropdown');

  button?.addEventListener('click', () => {
    menu.classList.toggle('hidden');
  });
});
